const importProductsDictIT = {
  importProductsFromCSVFile: "Carica un file .csv di seguito per importare i prodotti da esso",
  importTemplateExplanation:
    "Verranno importati SOLO i dati di base come titolo, descrizione, prezzo e immagini, dovrai comunque esaminare e rivedere ogni prodotto risultante e modificarli di conseguenza. Anche le varianti di prodotto non vengono importate e devono essere configurate di conseguenza.",
  fringeBenefitDownloadedSuccessfully: "Flexible benefit scaricato con successo",
  discharge: "Scarico",
  doYouWantToCancelTheProductBelow: "Vuoi annullare il voucher qui sotto?",
  wasDischargedFromFringeBenefit: "È stato licenziato dai Flexible benefit",
  associatedVoucher: "Voucher associati",
};

export default importProductsDictIT;
